// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper__inner-2fqQz";
var _4 = "image-2iQWp";
var _5 = "icon-f9mpH";
var _6 = "context-LpxMl";
var _7 = "action-33r5u";
var _8 = "content__wrapper-1UoD7";
var _9 = "content-12mZ6";
var _a = "title-hE3m_";
var _b = "text-20AIp";
var _c = "wrapper-3j50o";
var _d = "global-aXovF";
var _e = "info-eHdaR";
var _f = "success-DQimL";
var _10 = "error-3WGTM";
var _11 = "warning-229W5";
var _12 = "subscription-OAE7m";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper__inner", _4 as "image", _5 as "icon", _6 as "context", _7 as "action", _8 as "content__wrapper", _9 as "content", _a as "title", _b as "text", _c as "wrapper", _d as "global", _e as "info", _f as "success", _10 as "error", _11 as "warning", _12 as "subscription" }
export default { "__esModule": _1, "mobile": _2, "wrapper__inner": _3, "image": _4, "icon": _5, "context": _6, "action": _7, "content__wrapper": _8, "content": _9, "title": _a, "text": _b, "wrapper": _c, "global": _d, "info": _e, "success": _f, "error": _10, "warning": _11, "subscription": _12 }
